import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SeoHead from "../components/SeoHead";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [isError, setIsError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    setIsError(false);
    setSubmitting(true);

    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();

      if (!res.ok) {
        setIsError(true);
        setStatus(data.error || "Something went wrong. Please try again.");
        return;
      }

      setStatus(
        data.message ||
          "If an account exists for that email, a password reset link has been sent.",
      );
    } catch {
      setIsError(true);
      setStatus("Unable to send reset link. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <SeoHead
        title="Forgot Password – Ghost Inbox"
        description="Reset your Ghost Inbox account password. Enter your email to receive a secure reset link."
        path="/forgot-password"
        noindex
      />
      <div className="mx-auto flex max-w-md flex-1 flex-col justify-center px-6 py-16">
        <h1 className="text-2xl font-bold text-white">Reset your password</h1>
        <p className="mt-2 text-sm text-zinc-400">
          Enter the email address linked to your account. We&apos;ll send you a reset link if it
          exists in our system.
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1 block text-xs font-medium text-zinc-400">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full rounded-lg border border-zinc-700 bg-zinc-900 px-4 py-2.5 text-white focus:border-emerald-500 focus:outline-none"
            />
          </div>

          {status && (
            <p className={`text-sm ${isError ? "text-red-400" : "text-emerald-400"}`}>{status}</p>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-emerald-500 py-3 text-sm font-semibold text-zinc-950 hover:bg-emerald-400 disabled:opacity-60"
          >
            {submitting ? "Sending…" : "Send reset link"}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-zinc-500">
          Remember your password?{" "}
          <Link to="/login" className="text-emerald-400 hover:underline">
            Back to login
          </Link>
        </p>
      </div>
    </Layout>
  );
}

export default ForgotPassword;
